import type { NavBadge } from '@/config/nav';

interface NavBadgeDisplayProps {
  badge: NavBadge;
}

export function NavBadgeDisplay({ badge }: NavBadgeDisplayProps) {
  const { count } = badge.useCount();

  if (count <= 0) return null;

  const display = count > 99 ? '99+' : count;

  if (badge.variant === 'warning') {
    return (
      <span className="ml-auto flex h-5 min-w-5 items-center justify-center rounded-full border border-orange-500 bg-orange-500/15 px-1.5 text-[11px] font-bold text-orange-600 dark:text-orange-400">
        {display}
      </span>
    );
  }

  return (
    <span className="ml-auto flex h-5 min-w-5 items-center justify-center rounded-full border border-primary bg-primary/15 px-1.5 text-[11px] font-bold text-primary">
      {display}
    </span>
  );
}
